// extracted by mini-css-extract-plugin
export var alignCenter = "_96-d";
export var bannerShown = "_96-6";
export var buttonContent = "_96-0";
export var cardList = "_96-1";
export var centerContent = "_96-2";
export var chevron = "_96-3";
export var closePanelButton = "_96-k";
export var conversationContextContainer = "_96-l";
export var conversationDetailContainer = "_96-4";
export var detailWrapper = "_96-7";
export var dropdownButton = "_96-e";
export var dropdownTitle = "_96-9";
export var fullHeight = "_96-5";
export var hidden = "_96-a";
export var icon = "_96-b";
export var mergeSuggestionWrapper = "_96-m";
export var panel = "_96-i";
export var portalButtonsWrapper = "_96-c";
export var right = "_96-j";
export var tableSummaryContainer = "_96-8";
export var tableSummaryHeader = "_96-g";
export var threeDotsButton = "_96-f";
export var wide = "_96-h";